function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var chatMenuTemplate = require('./chat-manager-menu.template');
var ContactsList = require('./../../../../lib/saito/ui/modals/saito-contacts/saito-contacts');
var SaitoOverlay = require('./../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ChatList = require('./chat-list');
var ChatUserMenu = require('./chat-user-menu');
var SaitoUser = require('./../../../../lib/saito/ui/saito-user/saito-user');
var EXCLUDED_KEY_TYPES = new Set(['group', 'event', 'scheduled_call']);
var ChatManagerMenu = /*#__PURE__*/function () {
  function ChatManagerMenu(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var showCreationActions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !container;
    _classCallCheck(this, ChatManagerMenu);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.usesOverlay = !container;
    this.showCreationActions = showCreationActions;
    this.contactList = new ContactsList(app, mod, true);
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.chatList = new ChatList(app, mod);
    this.chatList.callback = function (gid) {
      var chatMenu = new ChatUserMenu(_this.app, _this.mod, _this.mod.returnGroup(gid));
      chatMenu.render();
    };
    this.selectedPublicKey = null;
    this.searchQuery = '';
    this.contactPublicKey = '';
    this.contactSearchPending = false;
    this.contactSearchError = '';
    this.contactLookupId = 0;
    this._onKeychainUpdated = null;
    this._detailOptionCallbacks = {};
  }
  return _createClass(ChatManagerMenu, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var title, container, settings, html;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              // A response for an earlier rendering must not replace the current field.
              this.contactLookupId++;
              this.contactSearchPending = false;
              if (!this.container) {
                // Title lives inside each sliding stage — not a stationary overlay > h2.
                this.overlay.show("<div class=\"module-settings-overlay\"></div>");
                this.container = '.module-settings-overlay';
              } else {
                // Remove any leftover outer title so it cannot sit outside the slider.
                title = document.querySelector("".concat(this.container, " > h2"));
                if (title) {
                  title.remove();
                }
              }
              container = document.querySelector(this.container);
              settings = container === null || container === void 0 ? void 0 : container.querySelector('.saito-module-settings');
              html = chatMenuTemplate(this.app, this.mod);
              if (settings) {
                settings.outerHTML = html;
              } else {
                this.app.browser.addElementToSelector(html, this.container);
              }
              this.renderContactList();
              if (this.selectedPublicKey) {
                this.showDetail(this.selectedPublicKey, false);
              } else {
                this.showHome(false);
              }
              this.attachEvents();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "returnDirectoryKeys",
    value: function returnDirectoryKeys() {
      return this.app.keychain.returnKeys().filter(function (key) {
        if (!(key !== null && key !== void 0 && key.publicKey)) {
          return false;
        }
        if (EXCLUDED_KEY_TYPES.has(key.type)) {
          return false;
        }
        // Legacy group marker (migrated to type on next keychain load).
        if (key.group) {
          return false;
        }
        return true;
      });
    }
  }, {
    key: "isBlocked",
    value: function isBlocked(publicKey) {
      return Array.isArray(this.mod.black_list) && this.mod.black_list.includes(publicKey);
    }
  }, {
    key: "truncatePublicKey",
    value: function truncatePublicKey() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
      var key = String(publicKey);
      if (key.length <= max) {
        return key;
      }
      return "".concat(key.slice(0, Math.max(6, Math.floor(max / 2) - 1)), "\u2026").concat(key.slice(-(Math.floor(max / 2) - 1)));
    }
  }, {
    key: "escapeHtml",
    value: function escapeHtml() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (typeof value !== 'string' && typeof value !== 'number') {
        return '';
      }
      return this.app.browser.escapeHTML(String(value));
    }

    /**
     * Local display name for a contact public key.
     *
     * Keychain stores aliases on `identifier`; returnUsername() reads that field.
     * Only a non-empty string identifier is treated as a usable alias. Booleans
     * (and the historical string "false" from sprompt cancel → String(false))
     * are not names — fall through to the established Anon-xxxxxx fallback.
     */
  }, {
    key: "contactDisplayName",
    value: function contactDisplayName(publicKey) {
      var key = this.app.keychain.returnKey(publicKey);
      var identifier = key === null || key === void 0 ? void 0 : key.identifier;
      if (typeof identifier === 'string') {
        var trimmed = identifier.trim();
        // "false" is the known corruption from String(boolean false) on cancel.
        if (trimmed && trimmed !== 'false') {
          return trimmed;
        }
      }
      var pk = String(publicKey || '');
      if (pk.length > 12) {
        return 'Anon-' + pk.substring(0, 6);
      }
      return pk;
    }
  }, {
    key: "matchesSearch",
    value: function matchesSearch(key, query) {
      if (!query) {
        return true;
      }
      var q = query.toLowerCase();
      var username = this.contactDisplayName(key.publicKey).toLowerCase();
      var identifier = typeof key.identifier === 'string' ? key.identifier.toLowerCase() : '';
      var publicKey = String(key.publicKey || '').toLowerCase();
      return username.includes(q) || identifier.includes(q) || publicKey.includes(q);
    }
  }, {
    key: "rootEl",
    value: function rootEl() {
      return document.querySelector("".concat(this.container, " .chat-settings"));
    }
  }, {
    key: "updateContactSearchUi",
    value: function updateContactSearchUi() {
      var _this2 = this;
      var root = this.rootEl();
      if (!root) {
        return;
      }
      var confirmed = Boolean(this.contactPublicKey);
      root.querySelector('.chat-settings-search-wrap').classList.toggle('hide-element', confirmed);
      var preview = root.querySelector('.chat-settings-search-preview');
      preview.classList.toggle('hide-element', !confirmed);
      preview.innerHTML = '';
      if (confirmed) {
        var user = new SaitoUser(this.app, this.mod, "".concat(this.container, " .chat-settings-search-preview"), this.contactPublicKey, this.escapeHtml(this.contactPublicKey), "<button type=\"button\" class=\"saito-icon-button chat-settings-search-edit\" title=\"Edit contact search\" aria-label=\"Edit contact search\"><i class=\"fa-solid fa-pen\" aria-hidden=\"true\"></i></button>");
        user.data_disable = true;
        user.render();
        preview.querySelector('.chat-settings-search-edit').onclick = function () {
          _this2.contactLookupId++;
          _this2.contactPublicKey = '';
          _this2.updateContactSearchUi();
          var input = root.querySelector('#chat-settings-search');
          input.focus();
          input.select();
        };
      }
      var button = root.querySelector('#chat-settings-add-contact');
      button.textContent = confirmed ? 'Add contact' : this.contactSearchPending ? 'Searching…' : 'Search';
      button.disabled = this.contactSearchPending || !confirmed && !this.searchQuery;
      button.setAttribute('aria-busy', String(this.contactSearchPending));
      root.querySelector('.chat-settings-search-status').textContent = this.contactSearchError;
    }
  }, {
    key: "updateContactSearchFromInput",
    value: function updateContactSearchFromInput() {
      var _this$rootEl;
      var input = (_this$rootEl = this.rootEl()) === null || _this$rootEl === void 0 ? void 0 : _this$rootEl.querySelector('#chat-settings-search');
      if (!input) {
        return;
      }
      this.contactLookupId++;
      this.searchQuery = input.value.trim();
      this.contactPublicKey = '';
      this.contactSearchPending = false;
      this.contactSearchError = '';
      // Length only gates validation; use the same public-key validator as Send.
      if (this.searchQuery.length >= 44 && this.searchQuery.length <= 45 && this.app.crypto.isPublicKey(this.searchQuery)) {
        this.contactPublicKey = this.searchQuery;
      }
      this.renderContactList();
      this.updateContactSearchUi();
    }
  }, {
    key: "searchContact",
    value: function () {
      var _searchContact = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _registry$isRegistryI;
        var _this$rootEl2, input, registry, identifier, lookupId, root, publicKey, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(this.contactSearchPending || !this.searchQuery)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              if (!this.contactPublicKey) {
                _context2.n = 3;
                break;
              }
              _context2.n = 2;
              return this.addContact(this.contactPublicKey);
            case 2:
              input = (_this$rootEl2 = this.rootEl()) === null || _this$rootEl2 === void 0 ? void 0 : _this$rootEl2.querySelector('#chat-settings-search');
              if (input) {
                input.value = '';
                this.updateContactSearchFromInput();
              }
              return _context2.a(2);
            case 3:
              if (!this.app.crypto.isPublicKey(this.searchQuery)) {
                _context2.n = 4;
                break;
              }
              this.contactPublicKey = this.searchQuery;
              this.updateContactSearchUi();
              return _context2.a(2);
            case 4:
              registry = this.app.modules.returnModule('Registry');
              identifier = this.searchQuery.includes('@') ? this.searchQuery : "".concat(this.searchQuery, "@saito");
              if (registry !== null && registry !== void 0 && (_registry$isRegistryI = registry.isRegistryIdentifier) !== null && _registry$isRegistryI !== void 0 && _registry$isRegistryI.call(registry, identifier)) {
                _context2.n = 5;
                break;
              }
              this.contactSearchError = registry ? 'Enter a valid Saito address or username.' : 'Registry search is unavailable.';
              this.updateContactSearchUi();
              return _context2.a(2);
            case 5:
              lookupId = ++this.contactLookupId;
              root = this.rootEl();
              this.contactSearchPending = true;
              this.contactSearchError = '';
              this.updateContactSearchUi();
              _context2.p = 6;
              _context2.n = 7;
              return registry.resolveIdentifier(identifier);
            case 7:
              publicKey = _context2.v;
              _context2.n = 9;
              break;
            case 8:
              _context2.p = 8;
              _t = _context2.v;
              console.warn('Chat: unable to resolve username', _t);
            case 9:
              if (!(lookupId !== this.contactLookupId || root !== this.rootEl())) {
                _context2.n = 10;
                break;
              }
              return _context2.a(2);
            case 10:
              this.contactSearchPending = false;
              if (publicKey && this.app.crypto.isPublicKey(publicKey)) {
                this.contactPublicKey = publicKey;
              } else {
                this.contactSearchError = 'No matching username found or registry unavailable.';
              }
              this.updateContactSearchUi();
            case 11:
              return _context2.a(2);
          }
        }, _callee2, this, [[6, 8]]);
      }));
      function searchContact() {
        return _searchContact.apply(this, arguments);
      }
      return searchContact;
    }()
  }, {
    key: "setStage",
    value: function setStage(stage) {
      var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var root = this.rootEl();
      if (!root) {
        return;
      }
      if (!animate) {
        root.classList.add('chat-settings-no-anim');
      }
      root.dataset.chatSettingsStage = stage;
      if (!animate) {
        void root.offsetWidth;
        root.classList.remove('chat-settings-no-anim');
      }
      var home = root.querySelector('[data-chat-settings-view="home"]');
      var detail = root.querySelector('[data-chat-settings-view="detail"]');
      if (home) {
        home.setAttribute('aria-hidden', stage === 'home' ? 'false' : 'true');
      }
      if (detail) {
        detail.setAttribute('aria-hidden', stage === 'detail' ? 'false' : 'true');
      }
    }

    /**
     * Collect optional-module contact actions via respondTo('user-menu').
     * Remap known module labels to the Contacts copy requested for this UI.
     */
  }, {
    key: "returnExternalContactOptions",
    value: function returnExternalContactOptions(publicKey) {
      var mods = this.app.modules.returnModulesRespondingTo('user-menu', {
        publicKey: publicKey
      }) || [];
      var options = [];
      // Preferred scan order for the two-column action grid (row-major).
      var slugRank = {
        store: 20,
        modtools: 30,
        redsquare: 40,
        stack: 50,
        videocall: 60,
        fileshare: 70,
        encrypt: 80
      };
      var _iterator = _createForOfIteratorHelper(mods),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _am$returnName, _this$mod$returnName, _this$mod;
          var am = _step.value;
          if (((_am$returnName = am.returnName) === null || _am$returnName === void 0 ? void 0 : _am$returnName.call(am)) === ((_this$mod$returnName = (_this$mod = this.mod).returnName) === null || _this$mod$returnName === void 0 ? void 0 : _this$mod$returnName.call(_this$mod))) {
            continue;
          }
          var item = am.respondTo('user-menu', {
            publicKey: publicKey
          });
          if (!item) {
            continue;
          }
          var items = item instanceof Array ? item : [item];
          var _iterator2 = _createForOfIteratorHelper(items),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _am$returnSlug, _slugRank$slug;
              var entry = _step2.value;
              if (!(entry !== null && entry !== void 0 && entry.callback)) {
                continue;
              }
              var slug = String(((_am$returnSlug = am.returnSlug) === null || _am$returnSlug === void 0 ? void 0 : _am$returnSlug.call(am)) || am.name || '').toLowerCase();
              var text = entry.text || 'Open';
              var icon = entry.icon || 'fa-solid fa-arrow-up-right-from-square';
              var image = entry.image || '';
              if (slug === 'redsquare') {
                text = 'View Posts';
              } else if (slug === 'store') {
                text = 'View Store';
              } else if (slug === 'stack') {
                // Stack's SVG mask often fails to render here; use the module FA blog icon.
                text = 'View Stack';
                icon = entry.icon || 'fa-solid fa-newspaper';
                image = '';
              }
              options.push({
                id: "ext-".concat(slug || options.length),
                text: text,
                icon: icon,
                image: image,
                callback: entry.callback,
                rank: (_slugRank$slug = slugRank[slug]) !== null && _slugRank$slug !== void 0 ? _slugRank$slug : 85
              });
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      options.sort(function (a, b) {
        var _a$rank, _b$rank;
        return ((_a$rank = a.rank) !== null && _a$rank !== void 0 ? _a$rank : 85) - ((_b$rank = b.rank) !== null && _b$rank !== void 0 ? _b$rank : 85);
      });
      return options;
    }
  }, {
    key: "renderContactList",
    value: function renderContactList() {
      var _this3 = this;
      var list = document.getElementById('chat-settings-list');
      if (!list) {
        return;
      }
      var keys = this.returnDirectoryKeys().filter(function (key) {
        return _this3.matchesSearch(key, _this3.searchQuery);
      }).sort(function (a, b) {
        var an = _this3.contactDisplayName(a.publicKey).toLowerCase();
        var bn = _this3.contactDisplayName(b.publicKey).toLowerCase();
        return an.localeCompare(bn);
      });
      if (!keys.length) {
        list.innerHTML = "<div class=\"chat-settings-empty\">".concat(this.searchQuery ? 'No contacts match your search' : 'No contacts in your keychain yet', "</div>");
        return;
      }
      list.innerHTML = keys.map(function (key) {
        var publicKey = key.publicKey;
        var name = _this3.contactDisplayName(publicKey);
        var identicon = _this3.app.keychain.returnIdenticon(publicKey);
        var secure = _this3.app.keychain.hasSharedSecret(publicKey);
        return "\n          <button\n            type=\"button\"\n            class=\"chat-settings-contact\"\n            role=\"listitem\"\n            data-publickey=\"".concat(_this3.escapeHtml(publicKey), "\"\n          >\n            <div class=\"saito-identicon-box\">\n              <img class=\"saito-identicon\" src=\"").concat(identicon, "\" alt=\"\">\n            </div>\n            <div class=\"chat-settings-contact-meta\">\n              <div class=\"chat-settings-contact-name\">\n                <span>").concat(_this3.escapeHtml(name), "</span>\n                ").concat(secure ? '<i class="fa-solid fa-lock chat-settings-contact-secure" title="Diffie-Hellman key established" aria-hidden="true"></i>' : '', "\n              </div>\n              <div class=\"chat-settings-contact-key\">").concat(_this3.escapeHtml(_this3.truncatePublicKey(publicKey)), "</div>\n            </div>\n            <i class=\"fa-solid fa-chevron-right chat-settings-contact-chevron\" aria-hidden=\"true\"></i>\n          </button>");
      }).join('');
    }
  }, {
    key: "renderDetailBody",
    value: function renderDetailBody(publicKey) {
      var _this4 = this;
      var body = document.getElementById('chat-settings-detail-body');
      if (!body) {
        return;
      }
      var name = this.contactDisplayName(publicKey);
      var identicon = this.app.keychain.returnIdenticon(publicKey);
      var hasDh = this.app.keychain.hasSharedSecret(publicKey);
      var blocked = this.isBlocked(publicKey);
      var external = this.returnExternalContactOptions(publicKey);
      this._detailOptionCallbacks = {};
      var optionRows = [];
      optionRows.push({
        id: 'chat-settings-open-chat',
        text: 'Open Chat',
        image: '/saito/icons/saito-chat-icon-solid.svg',
        kind: 'open-chat'
      });
      var _iterator3 = _createForOfIteratorHelper(external),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var opt = _step3.value;
          this._detailOptionCallbacks[opt.id] = opt.callback;
          optionRows.push(opt);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      if (blocked) {
        optionRows.push({
          id: 'chat-settings-unblock-row',
          text: 'Unblock',
          icon: 'fa-regular fa-circle-check',
          kind: 'unblock'
        });
      } else {
        optionRows.push({
          id: 'chat-settings-block-row',
          text: 'Block',
          icon: 'fa-solid fa-ban',
          kind: 'block'
        });
      }
      optionRows.push({
        id: 'chat-settings-remove-row',
        text: 'Remove from Contacts',
        icon: 'fa-solid fa-trash',
        kind: 'remove',
        danger: true
      });
      var optionsHtml = optionRows.map(function (opt) {
        var icon = opt.image ? "<span class=\"saito-modal-menu-option-icon\" style=\"--saito-menu-icon: url('".concat(opt.image, "')\" aria-hidden=\"true\"></span>") : "<i class=\"".concat(opt.icon, "\" aria-hidden=\"true\"></i>");
        return "<div id=\"".concat(_this4.escapeHtml(opt.id), "\" class=\"saito-modal-menu-option chat-settings-option").concat(opt.danger ? ' chat-settings-option-danger' : '', "\" data-kind=\"").concat(_this4.escapeHtml(opt.kind || 'external'), "\" data-publickey=\"").concat(_this4.escapeHtml(publicKey), "\">").concat(icon, "<div class=\"saito-modal-menu-option-label\">").concat(_this4.escapeHtml(opt.text), "</div></div>");
      }).join('');
      body.innerHTML = "\n      <div class=\"chat-settings-identity\">\n        <div class=\"saito-identicon-box\">\n          <img class=\"saito-identicon\" src=\"".concat(identicon, "\" alt=\"\">\n        </div>\n        <div class=\"chat-settings-identity-meta\">\n          <button type=\"button\" class=\"chat-settings-identity-name\" id=\"chat-settings-rename\" data-publickey=\"").concat(this.escapeHtml(publicKey), "\" title=\"Provide alias for user\">\n            ").concat(this.escapeHtml(name), "\n          </button>\n          <div class=\"chat-settings-identity-key-row\">\n            <div class=\"chat-settings-pubkey\" title=\"").concat(this.escapeHtml(publicKey), "\">").concat(this.escapeHtml(publicKey), "</div>\n            <button type=\"button\" class=\"saito-profile-copy-key\" id=\"chat-settings-copy-key\" data-publickey=\"").concat(this.escapeHtml(publicKey), "\" title=\"Copy public key\" aria-label=\"Copy public key\">\n              <i class=\"fas fa-copy\" aria-hidden=\"true\"></i>\n            </button>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"chat-settings-section-divider\"></div>\n\n      <div class=\"chat-settings-options-block\">\n        <div class=\"chat-settings-options saito-menu-select-heavy\">\n          ").concat(optionsHtml, "\n        </div>\n      </div>\n\n      <div class=\"chat-settings-section-divider\"></div>\n\n      <div class=\"chat-settings-encryption-block\">\n        ").concat(hasDh ? "<h3 class=\"chat-settings-section-heading\">Advanced Encryption</h3>\n        <div class=\"chat-settings-encryption-note\">Encryption uses a Diffie-Hellman shared secret on a separate key pair. Transactions to this public key are encrypted by default.</div>\n        <button type=\"button\" class=\"saito-button-secondary compact\" id=\"chat-settings-regenerate-dh\" data-publickey=\"".concat(this.escapeHtml(publicKey), "\">\n          Regenerate Encryption\n        </button>\n        <button type=\"button\" class=\"saito-button-secondary compact\" id=\"chat-settings-delete-dh\" data-publickey=\"").concat(this.escapeHtml(publicKey), "\">\n          Delete Encryption\n        </button>") : "<h3 class=\"chat-settings-section-heading\">Standard Encryption</h3>\n        <div class=\"chat-settings-encryption-note\">Shared secrets are generated from the normal Saito key pairs. On-chain messages are only encrypted when applications specifically opt in.</div>\n        <button type=\"button\" class=\"saito-button-secondary compact\" id=\"chat-settings-generate-dh\" data-publickey=\"".concat(this.escapeHtml(publicKey), "\">\n          Upgrade Encryption\n        </button>"), "\n      </div>\n    ");
    }
  }, {
    key: "showHome",
    value: function showHome() {
      var animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.selectedPublicKey = null;
      this.setStage('home', animate);
    }
  }, {
    key: "showDetail",
    value: function showDetail(publicKey) {
      var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.selectedPublicKey = publicKey;
      this.renderDetailBody(publicKey);
      this.setStage('detail', animate);
      this.attachDetailEvents();
    }
  }, {
    key: "unblockPublicKey",
    value: function unblockPublicKey(publicKey) {
      // Same persistence path as ChatUserMenu unblock / user-menu "Unblock and Chat":
      // mutate mod.black_list and saveOptions(). No dedicated unblock event exists.
      for (var i = this.mod.black_list.length - 1; i >= 0; i--) {
        if (this.mod.black_list[i] == publicKey) {
          this.mod.black_list.splice(i, 1);
          break;
        }
      }
      this.mod.saveOptions();
    }
  }, {
    key: "blockPublicKey",
    value: function blockPublicKey(publicKey) {
      if (!this.mod.black_list.includes(publicKey)) {
        this.mod.black_list.push(publicKey);
      }
      this.mod.saveOptions();
    }
  }, {
    key: "renameContact",
    value: function () {
      var _renameContact = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(publicKey) {
        var current, next, name;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              current = this.contactDisplayName(publicKey);
              _context3.n = 1;
              return sprompt('Provide alias for user', current);
            case 1:
              next = _context3.v;
              if (!(next === false || next == null)) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              if (!(typeof next !== 'string')) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2);
            case 3:
              name = next.trim();
              if (name) {
                _context3.n = 4;
                break;
              }
              return _context3.a(2);
            case 4:
              // Keychain stores display name as `identifier`; returnUsername() reads it.
              this.app.keychain.addKey(publicKey, {
                identifier: name
              });
              this.renderDetailBody(publicKey);
              this.attachDetailEvents();
              this.renderContactList();
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function renameContact(_x) {
        return _renameContact.apply(this, arguments);
      }
      return renameContact;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this5 = this,
        _this$rootEl3,
        _this$rootEl4;
      if (this._onKeychainUpdated) {
        this.app.connection.off('keychain-updated', this._onKeychainUpdated);
      }
      this._onKeychainUpdated = function () {
        _this5.renderContactList();
        if (_this5.selectedPublicKey) {
          if (_this5.app.keychain.hasPublicKey(_this5.selectedPublicKey)) {
            _this5.renderDetailBody(_this5.selectedPublicKey);
            _this5.attachDetailEvents();
          } else {
            _this5.showHome();
          }
        }
      };
      this.app.connection.on('keychain-updated', this._onKeychainUpdated);
      var search = (_this$rootEl3 = this.rootEl()) === null || _this$rootEl3 === void 0 ? void 0 : _this$rootEl3.querySelector('#chat-settings-search');
      if (search) {
        search.value = this.searchQuery;
        search.oninput = function () {
          return _this5.updateContactSearchFromInput();
        };
        search.onchange = function () {
          // Hiding a focused field can fire change after its input event or lookup.
          if (search.value.trim() !== _this5.searchQuery) {
            _this5.updateContactSearchFromInput();
          }
        };
        search.onkeydown = function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            void _this5.searchContact();
          }
        };
      }
      var list = document.getElementById('chat-settings-list');
      if (list) {
        list.onclick = function (e) {
          var row = e.target.closest('.chat-settings-contact');
          if (!row) {
            return;
          }
          var publicKey = row.dataset.publickey;
          if (publicKey) {
            _this5.showDetail(publicKey);
          }
        };
      }
      var addContact = (_this$rootEl4 = this.rootEl()) === null || _this$rootEl4 === void 0 ? void 0 : _this$rootEl4.querySelector('#chat-settings-add-contact');
      if (addContact) {
        addContact.onclick = function (e) {
          e.preventDefault();
          void _this5.searchContact();
        };
      }
      this.updateContactSearchUi();
      var audioToggle = document.getElementById('audio-notifications');
      if (audioToggle) {
        audioToggle.onchange = function (e) {
          if (e.currentTarget.checked) {
            _this5.mod.audio_notifications = true;
          } else {
            _this5.mod.audio_notifications = '';
          }
          _this5.mod.saveOptions();
        };
      }
      var autoOpen = document.getElementById('auto-open');
      if (autoOpen) {
        autoOpen.onchange = function (e) {
          _this5.mod.auto_open_community = Boolean(e.currentTarget.checked);
          _this5.mod.saveOptions();
        };
      }
      var back = document.getElementById('chat-settings-back');
      if (back) {
        back.onclick = function () {
          return _this5.showHome();
        };
      }
    }
  }, {
    key: "attachDetailEvents",
    value: function attachDetailEvents() {
      var _this6 = this;
      var renameBtn = document.getElementById('chat-settings-rename');
      if (renameBtn) {
        renameBtn.onclick = function () {
          return _this6.renameContact(renameBtn.dataset.publickey);
        };
      }
      var copyKey = document.getElementById('chat-settings-copy-key');
      if (copyKey) {
        copyKey.onclick = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
          var icon;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                _context4.n = 1;
                return navigator.clipboard.writeText(copyKey.dataset.publickey);
              case 1:
                icon = copyKey.querySelector('i');
                if (icon) {
                  icon.classList.remove('fa-copy');
                  icon.classList.add('fa-check');
                  setTimeout(function () {
                    icon.classList.remove('fa-check');
                    icon.classList.add('fa-copy');
                  }, 1500);
                }
              case 2:
                return _context4.a(2);
            }
          }, _callee4);
        }));
      }
      var generateDh = document.getElementById('chat-settings-generate-dh');
      if (generateDh) {
        generateDh.onclick = function () {
          var publicKey = generateDh.dataset.publickey;
          _this6.app.connection.emit('encrypt-key-exchange', publicKey);
          siteMessage('Diffie-Hellman key exchange started', 2000);
        };
      }
      var regenerateDh = document.getElementById('chat-settings-regenerate-dh');
      if (regenerateDh) {
        regenerateDh.onclick = function () {
          var publicKey = regenerateDh.dataset.publickey;
          _this6.app.connection.emit('encrypt-regenerate-key-exchange', publicKey);
          siteMessage('Requesting updated encryption key....', 2000);
          _this6.renderDetailBody(publicKey);
          _this6.attachDetailEvents();
        };
      }
      var deleteDh = document.getElementById('chat-settings-delete-dh');
      if (deleteDh) {
        deleteDh.onclick = function () {
          var publicKey = deleteDh.dataset.publickey;
          _this6.app.connection.emit('encrypt-delete-key-exchange', publicKey);
          siteMessage('Reverted to unencrypted communications', 2000);
          _this6.renderDetailBody(publicKey);
          _this6.attachDetailEvents();
        };
      }
      document.querySelectorAll('.chat-settings-option').forEach(function (row) {
        row.onclick = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
          var publicKey, kind, id, ok, callback;
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                publicKey = row.dataset.publickey;
                kind = row.dataset.kind;
                id = row.id;
                if (!(kind === 'open-chat')) {
                  _context5.n = 1;
                  break;
                }
                _this6.app.connection.emit('open-chat-with', {
                  key: publicKey
                });
                if (_this6.usesOverlay) {
                  _this6.overlay.close();
                }
                return _context5.a(2);
              case 1:
                if (!(kind === 'block')) {
                  _context5.n = 2;
                  break;
                }
                _this6.blockPublicKey(publicKey);
                siteMessage('Contact blocked', 1500);
                _this6.renderDetailBody(publicKey);
                _this6.attachDetailEvents();
                return _context5.a(2);
              case 2:
                if (!(kind === 'unblock')) {
                  _context5.n = 3;
                  break;
                }
                _this6.unblockPublicKey(publicKey);
                siteMessage('Contact unblocked', 1500);
                _this6.renderDetailBody(publicKey);
                _this6.attachDetailEvents();
                return _context5.a(2);
              case 3:
                if (!(kind === 'remove')) {
                  _context5.n = 6;
                  break;
                }
                _context5.n = 4;
                return sconfirm('Remove this contact from your keychain?');
              case 4:
                ok = _context5.v;
                if (ok) {
                  _context5.n = 5;
                  break;
                }
                return _context5.a(2);
              case 5:
                _this6.app.keychain.removeKey(publicKey);
                _this6.showHome();
                _this6.renderContactList();
                return _context5.a(2);
              case 6:
                callback = _this6._detailOptionCallbacks[id];
                if (typeof callback === 'function') {
                  callback(_this6.app, publicKey);
                }
              case 7:
                return _context5.a(2);
            }
          }, _callee5);
        }));
      });
    }
  }, {
    key: "addContact",
    value: function () {
      var _addContact = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var address,
          _args6 = arguments;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              address = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : null;
              if (address) {
                _context6.n = 2;
                break;
              }
              _context6.n = 1;
              return sprompt('Enter Address of Contact to Add:');
            case 1:
              address = _context6.v;
            case 2:
              if (address) {
                _context6.n = 3;
                break;
              }
              return _context6.a(2);
            case 3:
              if (this.app.crypto.isPublicKey(address)) {
                _context6.n = 4;
                break;
              }
              salert('Not a Network Address / Public Key');
              return _context6.a(2);
            case 4:
              salert("Adding ".concat(address, " as Contact"));
              this.app.keychain.addKey(address, {
                added: true
              });
              this.mod.returnOrCreateChatGroupFromMembers([this.mod.publicKey, address]);
              this.app.connection.emit('chat-manager-render-request');
              this.renderContactList();
            case 5:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function addContact() {
        return _addContact.apply(this, arguments);
      }
      return addContact;
    }()
  }, {
    key: "openNewChat",
    value: function openNewChat() {
      var _this7 = this;
      this.contactList.multi_select = false;
      this.contactList.title = 'New Chat';
      this.contactList.callback = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(person) {
          return _regenerator().w(function (_context7) {
            while (1) switch (_context7.n) {
              case 0:
                if (person) {
                  _this7.app.connection.emit('open-chat-with', {
                    key: person
                  });
                  if (_this7.usesOverlay) {
                    _this7.overlay.close();
                  }
                }
              case 1:
                return _context7.a(2);
            }
          }, _callee7);
        }));
        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }();
      this.contactList.render();
    }
  }, {
    key: "createGroup",
    value: function () {
      var _createGroup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _this8 = this;
        var name;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return sprompt('Choose a name for the group');
            case 1:
              name = _context8.v;
              if (name) {
                _context8.n = 2;
                break;
              }
              return _context8.a(2);
            case 2:
              this.contactList.multi_select = true;
              this.contactList.title = 'Invite Contacts';
              this.contactList.callback = function (members) {
                members.push(_this8.mod.publicKey);
                _this8.mod.sendCreateGroupTransaction(name, members);
              };
              if (this.app.keychain.returnKeys().length > 0) {
                this.contactList.render();
              } else {
                this.mod.sendCreateGroupTransaction(name);
              }
              if (this.usesOverlay) {
                this.overlay.close();
              }
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function createGroup() {
        return _createGroup.apply(this, arguments);
      }
      return createGroup;
    }()
  }, {
    key: "markAllRead",
    value: function markAllRead() {
      var _iterator4 = _createForOfIteratorHelper(this.mod.groups),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _this$mod$chat_manage;
          var group = _step4.value;
          group.unread = 0;
          if (group.txs.length) {
            group.last_read_message = group.txs[group.txs.length - 1].signature;
          }
          this.mod.saveChatGroup(group);
          (_this$mod$chat_manage = this.mod.chat_manager) === null || _this$mod$chat_manage === void 0 || (_this$mod$chat_manage = _this$mod$chat_manage.popups[group.id]) === null || _this$mod$chat_manage === void 0 || _this$mod$chat_manage.updateNotification(0);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      this.app.connection.emit('chat-manager-render-request');
      siteMessage('All chats marked as read', 1500);
    }
  }]);
}();
module.exports = ChatManagerMenu;